/*
 * Copyright (c) 2020, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */

const { getOwnPropertyDescriptor } = Object;

const {
  DOCUMENT_POSITION_CONTAINED_BY,
  DOCUMENT_POSITION_CONTAINS,
  DOCUMENT_POSITION_PRECEDING,
  DOCUMENT_POSITION_FOLLOWING,
  ELEMENT_NODE,
  TEXT_NODE,
  CDATA_SECTION_NODE,
  PROCESSING_INSTRUCTION_NODE,
  COMMENT_NODE,
  DOCUMENT_FRAGMENT_NODE,
} = Node;

const {
  appendChild,
  cloneNode,
  compareDocumentPosition,
  insertBefore,
  removeChild,
  replaceChild,
  hasChildNodes,
  getRootNode,
} = Node.prototype;

const { contains } = HTMLElement.prototype;

const firstChildGetter: (this: Node) => ChildNode | null = getOwnPropertyDescriptor(Node.prototype, 'firstChild')!.get!;

const lastChildGetter: (this: Node) => ChildNode | null = getOwnPropertyDescriptor(Node.prototype, 'lastChild')!.get!;

const textContentGetter: (this: Node) => string = getOwnPropertyDescriptor(Node.prototype, 'textContent')!.get!;

const parentNodeGetter: (this: Node) => (Node & ParentNode) | null = getOwnPropertyDescriptor(
  Node.prototype,
  'parentNode'
)!.get!;

const ownerDocumentGetter: (this: Node) => Document | null = getOwnPropertyDescriptor(Node.prototype, 'ownerDocument')!
  .get!;

const parentElementGetter: (this: Node) => Element | null = getOwnPropertyDescriptor(Node.prototype, 'parentElement')!
  .get!;

const textContextGetter: (this: Node) => string | null = getOwnPropertyDescriptor(Node.prototype, 'textContent')!.get!;

const childNodesGetter: (this: Node) => NodeListOf<Node & Element> = getOwnPropertyDescriptor(
  Node.prototype,
  'childNodes'
)!.get!;

const isConnected = getOwnPropertyDescriptor(Node.prototype, 'isConnected')!.get!;

export {
  // Node.prototype
  appendChild,
  childNodesGetter,
  cloneNode,
  compareDocumentPosition,
  insertBefore,
  isConnected,
  parentElementGetter,
  parentNodeGetter,
  removeChild,
  replaceChild,
  textContextGetter,
  ownerDocumentGetter,
  hasChildNodes,
  contains,
  firstChildGetter,
  lastChildGetter,
  textContentGetter,
  getRootNode,
  // Node
  DOCUMENT_POSITION_CONTAINS,
  DOCUMENT_POSITION_CONTAINED_BY,
  DOCUMENT_POSITION_PRECEDING,
  DOCUMENT_POSITION_FOLLOWING,
  // Node Types
  ELEMENT_NODE,
  TEXT_NODE,
  CDATA_SECTION_NODE,
  PROCESSING_INSTRUCTION_NODE,
  COMMENT_NODE,
  DOCUMENT_FRAGMENT_NODE,
};
